module.exports = __webpack_public_path__ + "static/media/blackboard.55528aa3.jpg";


//////////////////
// WEBPACK FOOTER
// /src/images/blackboard.jpg
// module id = 1596
// module chunks = 0